import { Component, OnInit, Input } from "@angular/core";
import { AzureMapConfig } from "@rubbl-azure-maps";
import { Location } from "@rubbl-core";

@Component({
  selector: "app-machine-location",
  templateUrl: "./machine-location.component.html",
  styleUrls: ["./machine-location.component.scss"],
})
export class MachineLocationComponent implements OnInit {
  @Input() location: Location;
  mapConfig: AzureMapConfig = new AzureMapConfig();

  constructor() {}

  ngOnInit() {
    if (this.location.point && (!this.location.latitude || !this.location.longitude)) {
      this.location.latitude = this.location.point.coordinates[1];
      this.location.longitude = this.location.point.coordinates[0];
    }

    this.mapConfig.showControls = false;
    this.mapConfig.zoom = 10;
    this.mapConfig.maxZoom = 10;
  }
}
